import { initializeApp } from "firebase/app"; 
import { getAuth } from  "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyADBftw3U_PRS-2PbWSQFxrT1B2GzVguug",
  authDomain: "zeeno-robotics.firebaseapp.com",
  projectId: "zeeno-robotics",
  storageBucket: "zeeno-robotics.firebasestorage.app",
  messagingSenderId: "758685974548",
  appId: "1:758685974548:web:b9faaf170c13dd653e2701"
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
export {auth};
export {db};
export {storage};

